/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamModelDto } from '../../models/team-model-dto';

export interface UserControllerCreateTeam$Params {
      body: TeamModelDto
}

export function userControllerCreateTeam(http: HttpClient, rootUrl: string, params: UserControllerCreateTeam$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerCreateTeam.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamModelDto>;
    })
  );
}

userControllerCreateTeam.PATH = '/user/teams';
